import ProductFeatures from "./ProductFeatures";
import SiteTypeOptions from "./SiteTypeOptions";
import UpcList from "./UpcList";
import { PRICE_LIST, PriceListType } from "src/config/priceTypeList";
import { getProductInfo } from "src/utils/storage/product";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { UseFormSetValue } from "react-hook-form";
import styles from "./RightDetailBox.module.scss";
import { SubmitBtn } from "components/Common/Form/SubmitBtn";
import SubscriptionDetail from "./SubscriptionDetail";
import DspList from "./DspList";
import { useTranslation } from "react-i18next";

interface IRightDetailBoxProps {
  toggleAskPromotionOn: boolean;
  isRenew?: boolean;
  isCheckPromotionCode?: string;
  isCheckAskPromotion?: boolean;
  setValue?: UseFormSetValue<any>;
}
const RightDetailBox = ({
  toggleAskPromotionOn,
  isRenew = false,
  setValue,
  isCheckPromotionCode,
  isCheckAskPromotion,
}: IRightDetailBoxProps) => {
  const { t } = useTranslation();
  const productInfo =
    PRICE_LIST({ t })[getProductInfo().key].filter(
      (item: PriceListType) => item.key === "premium"
    ).length > 0
      ? PRICE_LIST({ t })[getProductInfo().key].filter(
          (item: PriceListType) => item.key === "premium"
        )[0]
      : { key: "", name: "", featuresCnt: 0, upcCnt: -1 };
  const productKey = getProductInfo().key;
  return (
    <div className={styles.rightDetailBox}>
      {/* <form className="form"> */}
      <div className={styles.siteTypeOptions}>
        <SiteTypeOptions
          productKey={productKey}
          // handleChange={handleChange}
          isRenew={isRenew}
        />
      </div>
      <ProductFeatures />

      {toggleAskPromotionOn ? (
        <div>
          <SubscriptionDetail />
          {/* 사용자당 스토리지 용량 */}
          {/* <div className="flex align-center">
            <div className="width w-70p">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.userStorage")}
              </span>
            </div>
            <div className="width w-30p text right">
              <span className="form-item-title">
                <b className="text text--black">{userPerStorage}GB</b>
              </span>
            </div>
          </div> */}
          {!["DSPM", "DSP", "FIRESIDE"].includes(
            getProductFromSessionStorage()
          ) && (
            <UpcList
              productInfo={productInfo}
              setValue={setValue}
              // selectAppList={selectAppList}
              // setSelectAppList={setSelectAppList}
              // register={register}
              // applicationList={applicationList}
              // selectAppList={selectAppList}
              // handleChange={handleChange}
              // openExtDetailModal={openExtDetailModal}
            />
          )}
          <DspList />
          <SubmitBtn
            text={t("siteType.send")}
            className={styles.submitBtn}
            disabled={!isCheckAskPromotion}
          />
        </div>
      ) : (
        <div>
          {/* <hr /> */}
          {/* <UpcList productInfo={productInfo} setValue={setValue} /> */}
          <SubmitBtn
            text={t("siteType.subscribeBtn")}
            className={styles.submitBtn}
            disabled={
              isCheckPromotionCode !== "OK"
              // && nxacAppUids.length === 0
            }
          ></SubmitBtn>
          {/* <button
            type="submit"
            disabled={
              isCheckPromotionCode !== "OK"
              // && nxacAppUids.length === 0
            }
            // onClick={promotionApply}
            // onClick={() => console.log("버튼 클릭!")}
            className="btn btn-blue width w-100p mg mt-20 pd py-10"
          >
            {t("siteType.subscribeBtn")}
          </button> */}
        </div>
      )}

      {/* 추천인 */}
      {/* {toggleAskPromotionOn && (
        <div>
          <hr />
          <span className="form-item-title">
            {t("siteType.referralIdOptional")}
          </span>
          <div>
            <input
              id="referralId"
              {...register("referralId")}
              // name="referralId"
              // value={referralId}
              // onChange={handleChange}
              className="form-control custom-form width w-370"
              placeholder={t("siteType.enterIdEmail")}
            />
          </div>
        </div>
      )} */}
      {/* </form> */}
    </div>
  );
};

export default RightDetailBox;
